import { render, staticRenderFns } from "./AccountAdd.vue?vue&type=template&id=65bdcfa9"
import script from "./AccountAdd.vue?vue&type=script&lang=js"
export * from "./AccountAdd.vue?vue&type=script&lang=js"
import style0 from "./AccountAdd.vue?vue&type=style&index=0&id=65bdcfa9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports